import { render, staticRenderFns } from "./agePieChart.vue?vue&type=template&id=0947c319&"
import script from "./agePieChart.vue?vue&type=script&lang=js&"
export * from "./agePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports